<template>
  <div class="tab">
    <img
      v-if="markerIconMap.get(icon?.name)?.url"
      :src="markerIconMap.get(icon?.name)?.url"
      class="tab-icon"
    >
    <component
      :is="featureIconMap.get(icon?.name)?.svg"
      v-else
      :style="{'--feature-color': icon?.color}"
      class="tab-icon"
    />
  </div>
</template>

<script lang="ts">
import type {PropType} from 'vue';
import type {InfoWindowContent} from '@/lib/classes/InfoWindowContent';
import {blueGray} from '@/lib/colors';
import {markerIconMap, featureIconMap} from '@/services/MapService/Icons';

export default {
  name: 'InfoWindowTab',
  props: {
    tab: {
      type: Object as PropType<InfoWindowContent>,
      default: () => {},
    },
  },
  data() {
    return {
      markerIconMap,
      featureIconMap,
      icon: {
        name: '',
        color: '',
      },
    };
  },
  watch: {
    'tab.icon': {
      handler(newVal) {
        this.icon = newVal;
      },
      deep: true,
    },
  },
  beforeMount() {
    this.icon.color = this.tab?.icon?.color || blueGray;
    this.icon.name = this.tab?.icon?.name || '';
  },
  beforeUnmount() {
    this.tab?.host?.closeActions?.();
  },
};
</script>

<style scoped lang="scss">
  .tab {
    height: 42px;
    width: 42px;
    display: flex;
    align-items: center;

    &-icon {
      width: 60%;
      height: 60%;
      margin: 0 auto;

      :deep(.route-fill) {
        fill: var(--feature-color, #a5b1b7);
      }
      :deep(.polygon-inner-fill) {
        fill: var(--feature-color, main.$npGray);
      }
      :deep(.polygon-outer-fill) {
        fill: var(--feature-color, main.$npGray);
      }
      :deep(.polyline-stroke) {
        stroke: var(--feature-color, main.$npGray);
      }
      :deep(.icon-fill) {
        fill: var(--feature-color, main.$npGray);
      }
    }
  }
</style>
